<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="ch00_fm04_title"></a><a id="page_3"></a><img alt="image" src="images/title.jpg"/></p>
<p class="center2"><strong>OUR 10 FAVORITE INGREDIENTS</strong></p>
<p class="center2"><strong>MATT LEWIS &amp; RENATO POLIAFITO<br/><span class="small">PHOTOGRAPHS BY TINA RUPP</span></strong></p>
<p class="center2"><strong>STEWART, TABORI &amp; CHANG     NEW YORK</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_title.vue?24a77908